import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { IconButton } from '@totalsoft/rocket-ui';
import { ArrowBack } from '@mui/icons-material';

const HeaderLinks = ({ onClickClose }) => {
  const { t } = useTranslation();
  return (
    <IconButton fontSize='medium' color='transparent' tooltip={t('Tooltips.DocumentTemplate.BackToList')} onClick={onClickClose}>
      <ArrowBack />
    </IconButton>
  );
};

HeaderLinks.propTypes = {
  onClickClose: PropTypes.func.isRequired
};

export default HeaderLinks;
